import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDocument = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F1F5FC"
      fillRule="evenodd"
      d="m0 6.626 11.715-2.64 5.857-1.32 7.695 4.398 3.064 9.53 4.902 15.248-23.429 5.281z"
      clipRule="evenodd"
    />
    <path
      fill="#C5D2E8"
      fillRule="evenodd"
      d="m28.524 6.475-5.858 1.318-1.841-5.717z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m5.473 12.85-.297-.955 9.745-2.259.297.956zM7.33 18.998l-.294-.957 17.53-4.099.295.957zM8.88 24.13l-.294-.956 17.53-4.099.295.956z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="m13.173 31.386 5.856-1.325c1.078-.244 2.225.412 2.562 1.465s-.264 2.105-1.342 2.349L14.393 35.2c-1.078.243-2.225-.413-2.562-1.466s.264-2.104 1.342-2.348"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m27.842 32.566.305.954 7.808-1.767c1.886-.427 2.938-2.267 2.348-4.11l-.305-.954-.976.221.305.954c.421 1.316-.33 2.63-1.677 2.935z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDocument);

export default ForwardRef;
